<template>
    <div>
        <h2>{{ 'cancellation form header' | translation }}</h2>
        <p>
            Vielen Dank. Ihr Widerruf wurde erfolgreich übermittelt.
        </p>
    </div>
</template>

<script>
export default {
    name: 'CancellationConfirmation',
};
</script>

<style scoped></style>
